/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_EasyInputs */

const en_coach_workout_easy = /** @type {(inputs: Coach_Workout_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45min Easy`)
};

const de_coach_workout_easy = /** @type {(inputs: Coach_Workout_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45min Locker`)
};

/**
* | output |
* | --- |
* | "45min Easy" |
*
* @param {Coach_Workout_EasyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_easy = /** @type {((inputs?: Coach_Workout_EasyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_EasyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_easy(inputs)
	return de_coach_workout_easy(inputs)
});